import Button from "../Button";
import useNotice from "../../hooks/useNotice";
import {regMobileNo} from "../../api/login";
import {useForgetPassword, useSendCodeEmail} from "../../api/userPass";
import {useEffect, useState} from "react";
import {useAsyncEffect, useCountDown} from "ahooks";
import CheckBox from "../../mall-7/src/components/CheckBox";
import {useGetAgentIdByDomainName} from "../../api/agent";
import Modal from "../Modal";
import {useDispatch} from "react-redux";
import {setDrawerForgetPwd} from "../../reducer/actions";
import {useTranslation} from "react-i18next";
import cookies from "../../utils/cookies";

export default function ForgetPwdForm({ children }) {
  const { t } = useTranslation();
  const { loading, forgetPwd, query, inputHandle } = useForgetPassword();
  const [targetDate, setTargetDate] = useState();
  const [countdown] = useCountDown({ targetDate });
  const dispatch = useDispatch();
  const { sendCode } = useSendCodeEmail();
  const notice = useNotice();
  const agentInfo = cookies.getAgentInfo();
  
  const forgetPwdHandle = () => {
    console.log(query);
    if (!query.account) {
      return notice.warn(t('账号或者密码不能为空!'));
    }
    
    if (!query.pwd) {
      return notice.warn(t('账号密码不能为空!'));
    }
    
    if (!query.verifyCode) {
      return notice.warn(t('验证码不能为空!'));
    }
    
    if (query.confirmPwd !== query.pwd) {
      return notice.warn(t('两次输入的密码不相同!'));
    }
    
    forgetPwd(() => {
      dispatch(setDrawerForgetPwd(false));
    });
  };
  
  const getVerCode = async () => {
    
    if (!query.account) {
      return notice.warn(t('账号或者密码不能为空!'));
    }
    
    let data = await sendCode({ email: query.account });
    
    if (data) {
      notice.success(t('验证码已发送'));
      setTargetDate(Date.now() + 60000);
    }
  };
  
  
  return (
    children ? children({
        t,
        query,
        loading,
        setTargetDate,
        countdown,
        inputHandle,
        getVerCode,
        forgetPwdHandle,
      })
      : <>
        <div className={'mb-[15px]'}>
          <label className="text-[14px] hidden mb-[5px] md:block inp-must">
            {agentInfo.isAllowMobileno === '1' && t('手机号') + '/'}{t('邮箱')}
          </label>
          <input type="text"
                 placeholder={`${t('请输入')}${agentInfo.isAllowMobileno === '1'? t('手机号') + '/': '' }${t('邮箱')}`}
                 value={query.mobileno}
                 onChange={(e) => inputHandle(e, 'mobileno')}
                 className="p-[15px] container md:border border-bottom-1px mdmax:rounded-none border-[#d4d4d4] text-[15px]"/>
        </div>
        
        <div className="mb-[15px]">
          <label className="inp-must text-[14px] hidden mb-[5px] md:block">
            {t('验证码')}
          </label>
          <div className="flex">
            <input type="text"
                   placeholder={`${t('请输入')}${t('验证码')}`}
                   value={query.verifyCode}
                   onChange={(e) => inputHandle(e, 'verifyCode')}
                   className="p-[15px] container md:border border-bottom-1px mdmax:rounded-none border-[#d4d4d4] text-[15px] mr-4"/>
            <Button onClick={getVerCode}
                    disabled={countdown > 0}
                    className={'rounded-none bg-[#333] text-white w-[180px]'}>
              {
                countdown > 0
                  ? `${Math.round(countdown / 1000)}s`
                  : t('获取验证码')
              }
            </Button>
          </div>
        </div>
        
        <div className="mb-[15px]">
          <label className="inp-must text-[14px] hidden mb-[5px] md:block">
            {t('密码')}
          </label>
          <input type="password"
                 placeholder={`${t('请输入')}${t('密码')}`}
                 value={query.pwd}
                 onChange={(e) => inputHandle(e, 'pwd')}
                 className="p-[15px] container md:border border-bottom-1px mdmax:rounded-none border-[#d4d4d4] text-[15px]"/>
        </div>
        
        <div className="mb-[10px]">
          <label className="inp-must text-[14px] hidden mb-[5px] md:block">
            {t('重复密码')}
          </label>
          <input type="password"
                 placeholder={`${t('请输入')}${t('重复密码')}`}
                 value={query.confirmPwd}
                 onChange={(e) => inputHandle(e, 'confirmPwd')}
                 className="p-[15px] container md:border border-bottom-1px mdmax:rounded-none border-[#d4d4d4] text-[15px]"/>
        </div>
        
        <Button onClick={forgetPwdHandle}
                loading={loading}
                className="rounded-none mdmax:rounded-full container text-[14px]
                         py-[12px] bg-[#333] text-white mb-[5px] mt-[60px]">
          {t('提交')}
        </Button>
      </>
  );
}
